import React, { useMemo } from "react";
import { Outlet } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { VENUE_TYPES } from "../../lib/consts/venueTypes";

/*
 * Public, auth-free wrapper that renders the REAL app shell (Layout →
 * SidebarBest + HeaderNew) around a /dev preview page, by supplying a mock
 * UserContext value (role + venueType) so the sidebar renders in full.
 *
 * Lets you validate a page inside the real sidebar/header without logging in.
 * There is NO session token, so any authenticated fetch returns empty: the
 * layout/chrome is faithful, the data is not. Pages that need real data have
 * their own authenticated route.
 *
 * Generic on purpose — any /dev/*-shell route can reuse it.
 *
 * The array order MUST mirror the value of context/UserContext.jsx:
 *   [token, setToken, ownedShops, venueID, venueName, venueImage, email,
 *    accessPrivileges, allVenues, changeVenue, refreshVenues, venueType,
 *    venueActivationStatus, venueSubscriptionStatus, canManageProducts,
 *    venueTrialEndsAt]
 */
export default function DevShellPreview() {
  const value = useMemo(() => {
    const v = new Array(16).fill(undefined);
    v[0] = null;                        // token (no session → empty data)
    v[1] = () => {};                    // setToken
    v[2] = [];                          // ownedShops
    v[3] = null;                        // venueID
    v[4] = "Sevilla Centro";            // venueName
    v[5] = null;                        // venueImage
    v[6] = "preview@dev";               // email
    v[7] = "superadmin";                // accessPrivileges → renders the full sidebar
    v[8] = [];                          // allVenues
    v[9] = () => {};                    // changeVenue
    v[10] = () => {};                   // refreshVenues
    v[11] = VENUE_TYPES.CANNABIS_CLUB;  // venueType
    v[12] = "active";                   // venueActivationStatus
    v[13] = "active";                   // venueSubscriptionStatus
    v[14] = true;                       // canManageProducts
    v[15] = "";                         // venueTrialEndsAt (matches the "" default)
    return v;
  }, []);

  return (
    <UserContext.Provider value={value}>
      <Outlet />
    </UserContext.Provider>
  );
}
